<div class="stick-top" *ngIf="!siteId">
  <mat-toolbar>
    <mat-icon>door_sliding</mat-icon> Secure Access Cabinets
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/access/saCabinets/0">
        <mat-icon>add</mat-icon>
        Create a new Secure Access Cabinet
      </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th>
          <div class="vbox">
            Company
            <micro-company-select *ngIf="auth.hasRole('COMPANY_ADMIN')" [(companyId)]="filter.companyId"></micro-company-select>
            <micro-saHostCompany-select *ngIf="!auth.hasRole('COMPANY_ADMIN')" [(companyId)]="filter.companyId" id="companyId" name="companyId" [includeHosted]="true"></micro-saHostCompany-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            Name
            <input [(ngModel)]="filter.name">
          </div>
        </th>
        <th>
          <div class="vbox">
            Serial Number
            <input [(ngModel)]="filter.serialNumber">
          </div>
        </th>
        <th *ngIf="!this.siteId">
          <div class="vbox">
            Site
<!--            <micro-site-select [(siteId)]="filter.siteId"></micro-site-select>-->
            <input [(ngModel)]="filter.siteName">
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td>
          <micro-company-lookup [companyId]="element.companyId" [link]="false"></micro-company-lookup>
        </td>
        <td><a routerLink="/access/saCabinets/{{element.id}}">{{element.name}}</a></td>
        <td [matTooltip]="element.serialNumber">{{element.serialNumber}}</td>
        <td *ngIf="!this.siteId"><micro-site-lookup [siteId]="element.siteId"></micro-site-lookup></td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
